import { evalAuthHeaders, getEvalBase } from '../../evalApiBase'
import {
  buildRunsListQuery,
  EvalRunAccepted,
  EvalRunCreateInput,
  EvalRunDetail,
  EvalRunListResponse,
  RunFilters,
} from './runsAdminModel'

async function readErrorDetail(res: Response): Promise<string | null> {
  try {
    const body = await res.json()
    if (body && typeof body.detail === 'string') {
      return body.detail
    }
  } catch {
    // fall through
  }
  return null
}

export async function listRuns(filters: RunFilters): Promise<EvalRunListResponse> {
  const query = buildRunsListQuery(filters)
  const res = await fetch(`${getEvalBase()}/v1/eval-runs?${query}`, {
    headers: evalAuthHeaders(),
  })
  if (!res.ok) {
    throw new Error(`Runs list failed: ${res.status}`)
  }
  return res.json()
}

export async function getRun(runId: string): Promise<EvalRunDetail> {
  const res = await fetch(`${getEvalBase()}/v1/eval-runs/${runId}`, {
    headers: evalAuthHeaders(),
  })
  if (!res.ok) {
    throw new Error(`Run fetch failed: ${res.status}`)
  }
  return res.json()
}

export async function createRun(
  input: EvalRunCreateInput,
): Promise<EvalRunAccepted> {
  const res = await fetch(`${getEvalBase()}/v1/eval-runs`, {
    method: 'POST',
    headers: { ...evalAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  })
  if (!res.ok) {
    // Surface the backend detail — an empty selection or a selection that
    // matches no cases returns 422 with an actionable message.
    const detail = await readErrorDetail(res)
    throw new Error(detail || `Run create failed: ${res.status}`)
  }
  return res.json()
}
